exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".device-list {\n  min-height: 320px;\n}\n.device-list .station-list {\n  width: 440px;\n  height: 100px;\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  margin-top: 30px;\n}\n.device-list .station-list ul {\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n.device-list .station-list ul li {\n  flex: 1;\n  border-right: 1px solid #e5e5e5;\n  margin: 30px 0;\n  font-size: 18px;\n  height: 36px;\n  line-height: 36px;\n  text-align: center;\n}\n.device-list .station-list ul li:last-child {\n  border: none;\n}\n.device-list .tip {\n  padding: 30px;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/remote/station/index.less
// module id = 1512
// module chunks = 0